<template>
  <BaseModal
    name="jobtitlesModal"
    width="1280"
    @before-close="closeModal"
    @before-open="openModal"
    :clickToClose="false"
    :shiftY="0.5"
    :adaptive="true"
    height="725"
    classes="bg-white shadow-none position-relative"
  >
    <BaseLoader v-if="localLoading"></BaseLoader>
    <div
      class="d-flex justify-content-between px-30 py-10 align-items-center position-relative"
    >
      <div class="d-flex text-dark fsc-12 fw-medium">
        Редактирование должности
      </div>
      <button
        type="button"
        class="btn-close p-0"
        @click="$modal.hide('jobtitlesModal')"
      ></button>
    </div>
    <vue-tabs
      v-model="activateTab"
      @tab-change="handleTabChange"
      class="flex-grow-1"
    >
      <v-tab
        :title="dataLang['reg_employee_4']"
        :data-name="dataLang['reg_employee_4']"
      >
        <div class="container-fluid px-25" style="height: 598px">
          <div class="row gx-0">
            <div class="col-12">
              <div class="tw-flex tw-gap-[10px] tw-items-center tw-mt-[15px]">
                <div class="tw-text-[14px] tw-text-forText">
                  {{ dataLang["reg_employee_20"] }}
                </div>
                <BaseInputNew
                  inputClass="tw-app-input-type-3"
                  placeholder=""
                  style="width: 350px"
                  @input="updateValue"
                  horizontalTitle
                  inputName="employee_jobtitles__name"
                  signClass="ws-nowrap d-block"
                  :value="dataForModal?.employee_jobtitles__name"
                />
              </div>
            </div>
          </div>
        </div>
      </v-tab>
      <v-tab :title="dataLang['reg_employee_23']" data-name="calc">
        <div class="container-fluid px-25">
          <div class="row gx-0">
            <div class="col-12">
              <div
                class="system-block mt-10 position-relative"
                style="height: 568px; margin-bottom: 20px"
              >
                <p class="fsc-11" v-if="!rulesList.length">
                  Вам доступны все страницы
                </p>
                <BaseCheckboxV2
                  placeholder=""
                  v-model="isLock"
                  v-if="rulesList.length"
                  @oncheckeds="({ value }) => selectAll(value)"
                  ><span class="text-dark">{{
                    dataLang["reg_employee_21"]
                  }}</span>
                </BaseCheckboxV2>
                <div class="d-flex gap-5 mt-20" v-if="rulesList.length">
                  <div
                    class="d-flex gap-5 flex-column flex-grow-1"
                    v-for="item of rulesList"
                    :key="item.menu__id"
                  >
                    <div
                      style="
                        padding: 8px;
                        background-color: #546887;
                        font-size: 9px;
                        color: #fff;
                      "
                    >
                      ({{ item.menu__number }}) {{ dataLang[item.menu__item] }}
                    </div>
                    <BaseCheckboxV2
                      v-for="child of item.children"
                      :key="child.menu__id"
                      placeholder=""
                      v-model="child.auth_jobtitles_menu_rules__state"
                      signClass="fsc-9"
                      @oncheckeds="
                        (data) =>
                          updateCheckedPage({
                            name: child.auth_jobtitles_menu_rules__menu_id,
                            value: data.value,
                          })
                      "
                    >
                      <span class="text-dark">
                        ({{ child.menu__number }})
                        {{ dataLang[child.menu__item] }}
                      </span>
                    </BaseCheckboxV2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-tab>
      <v-tab
        :title="dataLang['reg_employee_24']"
        :data-name="dataLang['reg_employee_24']"
      >
        <div class="container-fluid px-25">
          <div class="row gx-0">
            <div class="col-12">
              <div
                class="system-block mt-10"
                style="height: 568px; margin-bottom: 20px"
              ></div>
            </div>
          </div>
        </div>
      </v-tab>
    </vue-tabs>
    <div class="tw-flex tw-gap-[10px] tw-mt-[5px] tw-justify-end tw-pr-[15px]">
      <button
        @click="$modal.hide('jobtitlesModal')"
        class="tw-app-btn-muted tw-app-btn-muted-lg"
      >
        Отменить
      </button>
      <button
        @click="(data) => saveModal(data, true)"
        class="tw-app-btn-primary tw-app-btn-primary-lg"
      >
        Сохранить и закрыть
      </button>
    </div>
  </BaseModal>
</template>

<script>
import GeneralService from "@/api/GeneralService";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import { mapActions, mapState, mapGetters } from "vuex";
import EventBus from "@/event-bus.js";

export default {
  components: {
    VueTabs,
    VTab,
  },
  props: {
    dataModal: {
      type: Object,
    },
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      employeeJobtitlesId: null,
      localLoading: false,
      dataForModal: {},
      activateTab: "",
      updatedValues: {},
      jobtitlesList: [],
      rulesList: [],
      checkedPages: [],
      isLock: false,
    };
  },
  methods: {
    selectAll(val) {
      this.rulesList.forEach((item) =>
        item.children.forEach((child) => {
          if (val == true) {
            child.auth_jobtitles_menu_rules__state = true;
          } else {
            child.auth_jobtitles_menu_rules__state = false;
          }
        })
      );
      this.checkedPages = this.checkAllFunc(this.rulesList, val);
    },

    checkAllFunc(data, type) {
      let thinkData = [];
      data.forEach((el) => {
        thinkData.push({
          auth_jobtitles_menu_rules__menu_id:
            el.auth_jobtitles_menu_rules__menu_id,
          auth_jobtitles_menu_rules__status: type,
        });

        if (el.children) {
          thinkData.push(...this.checkAllFunc(el.children, type));
        }
      });

      return thinkData;
    },
    closeModal() {
      this.employeeJobtitlesId = null;
      this.dataForModal = {};
      this.updatedValues = {};
      this.jobtitlesList = [];
      this.activateTab = "";
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },

    updateCheckedPage(data) {
      let findData = this.checkedPages.findIndex(
        (x) => x.auth_jobtitles_menu_rules__menu_id == data.name
      );

      if (findData == -1) {
        this.checkedPages.push({
          auth_jobtitles_menu_rules__menu_id: data.name,
          auth_jobtitles_menu_rules__status: data.value,
        });
      } else {
        this.checkedPages[findData] = {
          auth_jobtitles_menu_rules__menu_id: data.name,
          auth_jobtitles_menu_rules__status: data.value,
        };
      }
    },

    async saveModal(oldTab, isCloseModal) {
      try {
        switch (
          oldTab instanceof PointerEvent ? this.activateTab : oldTab.title
        ) {
          case this.dataLang["reg_employee_4"]:
            if (Object.keys(this.updatedValues).length) {
              this.localLoading = true;
              GeneralService.edit(`/jobtitles/${this.employeeJobtitlesId}`, {
                ...this.updatedValues,
              })
                .then((data) => {
                  this.updatedValues = {};
                  this.$toast.success(data.data.message);
                  EventBus.$emit("updateContentDataJobtitles", isCloseModal);
                })
                .catch((e) => {
                  this.$toast.error(e.response.data.message, {
                    duration: 5000,
                  });
                  this.activateTab =
                    oldTab instanceof PointerEvent
                      ? this.activateTab
                      : oldTab.title;
                })
                .finally(() => {
                  this.localLoading = false;
                });
            }
            break;
          case this.dataLang["reg_employee_23"]:
            if (Object.keys(this.checkedPages).length) {
              this.localLoading = true;
              GeneralService.edit(
                `/jobtitles/${this.employeeJobtitlesId}/rules`,
                this.checkedPages
              )
                .then((data) => {
                  this.checkedPages = [];
                  EventBus.$emit("updateContentDataJobtitles", isCloseModal);
                  this.$toast.success(data.data.message);
                })
                .catch((e) => {
                  this.$toast.error(e.response?.data?.message, {
                    duration: 5000,
                  });
                  this.activateTab =
                    oldTab instanceof PointerEvent
                      ? this.activateTab
                      : oldTab.title;
                })
                .finally(() => {
                  this.localLoading = false;
                });
            }
            break;
        }
      } catch (error) {
      } finally {
      }
    },
    async handleTabChange(tabIndex, newTab, oldTab) {
      if (newTab.title !== oldTab.title) {
        await this.saveModal(oldTab, false);
      }
    },
    openModal(dataFromPage) {
      this.localLoading = true;
      this.employeeJobtitlesId = dataFromPage.params?.employee_jobtitles__id;
      this.dataForModal = dataFromPage.params;
      Promise.all([
        GeneralService.get(`/jobtitles/${this.employeeJobtitlesId}/rules`)
          .then((data) => {
            this.rulesList = data.data.data;
          })
          .catch((e) => {}),
      ])
        .then((data) => {})
        .finally(() => {
          this.localLoading = false;
        });
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},
  watch: {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
